<template>
	<div class="yj-upload">
		<div class="yj-button yj-button--primary hide" :class="[ size ? 'yj-button--' + size : '']" :id="btnID"></div>
		<span class="yj-upload-type-button" v-if="!type">
			<yj-button type="primary" @click="chooseFile" :loading="loading" :size="size" :disabled="uploadDisabled">{{btnName}}</yj-button>
			<span class="yj-upload-type-button-list" v-if="loading">{{fileNames}}</span>
			<yj-link type="primary" @click="download()" v-else :disabled="fileList.length > 1">{{fileNames}}</yj-link>
		</span>
		<span class="yj-upload-type-picture" v-else-if="type === 'picture'">
			<ul class="yj-upload-list yj-upload-list--picture-card">
				<li class="yj-upload-list__item is-success" v-for="item,index in pictureFileList">
					<img :src="resource + '/' + item.groupName + '/' + item.filePath" alt="" class="yj-upload-list__item-thumbnail" />
					<a class="yj-upload-list__item-name">
						<i class="yj-icon-docx"></i>{{item.name}}
					</a>
					<label class="yj-upload-list__item-status-label">
						<i class="yj-icon-sure"></i>
					</label>
					<span class="yj-upload-list__item-actions">
						<span class="yj-upload-list__item-preview" @click="preview(item,index)">
							<i class="yj-icon-magnify"></i>
						</span>
					<span class="yj-upload-list__item-delete" @click="remove(index)" v-if="!uploadDisabled">
							<i class="yj-icon-del"></i>
						</span>
					</span>
				</li>
			</ul>
			<div class="yj-upload yj-upload--picture-card" v-if="!uploadDisabled&&pictureFileList.length<maxSize" @click="chooseFile" v-loading="loading">
				<i class="yj-icon-add"></i>
			</div>
			<yj-dialog :visible.sync="imgDialogVisible" append-to-body>
			  <img width="100%" :src="imgShowURL" alt="">
			</yj-dialog>
		</span>
		<span class="yj-upload-type-custom" v-else-if="type === 'custom'">
			<slot></slot>
		</span>
	</div>
</template>
<script>
	import $ from 'jquery';
	import Webuploader from './webuploader';
	
	export default {
		name: 'YjUpload',

		mixins: [Webuploader],
		
		inject: {
			yjForm: {
				default: ''
			}
		},

		props: {
			disabled: Boolean,
			type: {
				type: String,
				default: ''
			},
			size: {
				type: String,
				default: ''
			},
			resource: {
				type: String,
				required: true
			},
			maxSize: {
				type: Number,
				default: 5
			}
		},

		data() {
			return {
				loading: false,
				btnName: '选择文件',
				fileList: [],
				pictureFileList: [],
				imgShowURL: '',
				imgDialogVisible: false
			};
		},

		computed: {
			fileNames() {
				if(this.fileList.length == 1){
					return this.fileList[0].name;
				}else if(this.fileList.length > 1){
					return this.fileList[0].name + '等' + this.fileList.length +'个文件';
				}
			},
			uploadDisabled() {
				return this.disabled || (this.yjForm || {}).disabled;
			}
		},

		methods: {
			chooseFile(){
				if(this.loading){
					return;
				}
				$(this.$el.querySelector('#' + this.btnID )).find('.webuploader-element-invisible').trigger('click');
			},
			download(){
				window.open(this.resource + '/' + this.fileList[0].groupName + '/' + this.fileList[0].filePath);
			},
			remove(index){
				this.pictureFileList.splice(index,1);
			},
			preview(item,index){
				this.imgShowURL = this.resource + '/' + item.groupName + '/' + item.filePath;
				this.imgDialogVisible = true;
			}
		}

	}
</script>



// WEBPACK FOOTER //
// src/components/upload/src/upload.vue